import objectTypes from '../../constants/ObjectTypes';
import customFieldsService from '../../services/CustomFieldsService';
import uiService from '../../services/UIService';
import scorableItemNumberingService from '../../services/questionView/ScorableItemNumberingService';
import questionReader from '../../store/readHelpers/QuestionReader';
import sessionReader from '../../store/readHelpers/SessionReader';
import uiReader from '../../store/readHelpers/uiReader';
import themeServices from '../../themes/ThemeServices';

const questionRubricBlockWithTitleSelector = {
    selectShowTitle(question) {
        const themeInstance = themeServices.getThemeInstance();
        const useNumberPerInteraction = scorableItemNumberingService.useNumberPerInteraction();
        const isAudioScriptsContext = sessionReader.isContextPreviewAudioScript();
        const hideScorableItemHeadline = themeInstance.shouldHideScorableItemHeadline(question);
        const isPrintBasedMPCMultiAnswer = sessionReader.isPrintStylePaperBased() && customFieldsService.isMPCMultiAnswer(question);
        const isQuestionStimulus = question.objectType === objectTypes.STIMULUS;
        return useNumberPerInteraction && !hideScorableItemHeadline && !isPrintBasedMPCMultiAnswer && !isAudioScriptsContext && !isQuestionStimulus;
    },

    selectShowRubric(customFields) {
        return uiReader.showQuestionRubric() && !!customFields;
    },

    selectUseDynamicRubric(showRubric, question) {
        return showRubric
            && uiReader.showDynamicRubric()
            && questionReader.hasDynamicRubricSupport(question);
    },

    selectQuestionRubricTitle(section, contentRevisionId) {
        const isVerticalLayout = uiService.isVerticalLayout(section);
        const isCeq = themeServices.isCeq();
        const isPrintOrPdfView = sessionReader.isViewMediaPrintOrPdf();
        const isMppOnForCEQPaperBased = themeServices.getThemeInstance().shouldRenderPaperBasedRubric();
        const isPaperBased = sessionReader.isPrintStylePaperBased();

        if (
            (isCeq &&
            section &&
            !isPrintOrPdfView &&
            !isVerticalLayout) || (section && isPrintOrPdfView && isMppOnForCEQPaperBased && isPaperBased)
        ) {
            return scorableItemNumberingService.getSectionTitle(section);
        }

        return scorableItemNumberingService.getQuestionTitle(contentRevisionId);
    },

    selectProps(ownProps) {
        const { question, section } = ownProps;
        const { contentItemId, contentRevisionId, number, customFields } = question;

        const showRubric = this.selectShowRubric(customFields);


        return {
            useDynamicRubric: this.selectUseDynamicRubric(showRubric, question),
            scorableItemId: `item_${contentItemId}_${number}`,
            showRubric,
            showTitle: this.selectShowTitle(question),
            questionRubricTitle: this.selectQuestionRubricTitle(section, contentRevisionId),
        };
    },
};

export default questionRubricBlockWithTitleSelector;
